// ManualViewer.js
import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import axios from "axios";

const ManualViewer = ({ serialNumber }) => {
  const [manualUrl, setManualUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchManualUrl = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/manual/${serialNumber}`, {
          withCredentials: true,
        });

        if (response.status === 200 && response.data.url) {
          setManualUrl(response.data.url);
        } else {
          setError("Handleiding onbeschikbaar");
        }
      } catch (err) {
        setError(err.response?.status === 404 ? "Handleiding onbeschikbaar" : "Error loading manual.");
      } finally {
        setLoading(false);
      }
    };

    fetchManualUrl();
  }, [serialNumber]);

  const handleOpenManual = () => {
    if (manualUrl) window.open(manualUrl, "_blank");
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="relative">
        {loading ? (
          <span className="text-gray-500">Loading...</span>
        ) : manualUrl ? (
          <span
            className="underline text-xl font-bold text-gray-800 hover:text-blue-800 cursor-pointer"
            onClick={handleOpenManual}
          >
            Handleiding
            <ArrowRight className="ml-2 w-5 h-5 text-gray-800 inline-block" />
          </span>
        ) : (
          <span className="text-sm text-red-500 font-semibold">{error || "Handleiding onbeschikbaar"}</span>
        )}
        <p className="text-xs md:text-sm text-gray-600">Bekijken</p>
      </div>
    </div>
  );
};

export default ManualViewer;